module.exports = __webpack_public_path__ + "files/ea89c657057bcd80dcfa03b7118df072.png";